import { render, staticRenderFns } from "./PersonManage.vue?vue&type=template&id=17fdc29a&scoped=true&"
import script from "./PersonManage.vue?vue&type=script&lang=js&"
export * from "./PersonManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fdc29a",
  null
  
)

export default component.exports